import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FlashCardModel, Media, QuestionModel } from 'src/app/api/models';
import { DialogService } from 'src/app/cms/common/dialog.service';
import { environment } from 'src/environments/environment';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'qa-image-display',
  templateUrl: './image-display.component.html',
  styleUrls: ['./image-display.component.scss'],
  imports: [MatIconButton, MatIcon],
})
export class ImageDisplayComponent implements OnInit {
  @Input() model: QuestionModel | FlashCardModel;

  mediaBucket = environment.s3.mediaBucket;
  youtubeLink: SafeUrl | undefined;

  constructor(private dialog: DialogService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url = (this.model as FlashCardModel)?.youtube_link_question;
    if (url) {
      this.youtubeLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  showImage(media: Media): void {
    const url = `${environment.mediaUrl}/${media.uuid}.${media.file_ext}`;
    this.dialog.showImage(url);
  }
}
